import axios from "axios";

import { BASE_URL } from "../../src/utils/api_base_url_configration";


export const getAttributeServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "attribute/list", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
export const addAttributeServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "attribute/create", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
export const updateAttributeServ = async (formData) => {
  try {
    const response = await axios.put(BASE_URL + "attribute/update", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
export const deleteAttributeServ = async (id) => {
  try {
    const response = await axios.delete(BASE_URL + "attribute/delete/"+id);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
